import {
  FeatureFlag,
  useNoUserFeatureFlagWithStatus,
} from "@vega-api/extended/auth/useFeatureFlag";
import {
  useInvestorInvestorInvitationCheck,
  useInvestorInvestorInvitationComplete,
} from "@vega-api/generated/auth-invitation-investor-investor-v1/auth-invitation-investor-investor-v1";
import {
  useInvitationCheck,
  useInvitationComplete,
} from "@vega-api/generated/auth-invitation-v1/auth-invitation-v1";
import { LoadingSpinner } from "@vega-core/components/Loaders/LoadingSpinner/LoadingSpinner";
import { usePublicConfig } from "@vega-core/hooks/usePublicConfig";
import { LPAuthPaths } from "@vega-modules/paths";

import { InvitationRegistration } from "../../Auth/Registration/InvitationRegistration";
import { getLPLoginFaqItems } from "../Login/lpLoginFaq";

export const LPRegistrationNew = () => {
  // Pre-auth read: the post-auth useFeatureFlag never resolves on this
  // unauthenticated page, so the flag would default to false and pick the v1
  // hooks even when v2 is enabled.
  const { isEnabled: isInvitationV2, isLoading } =
    useNoUserFeatureFlagWithStatus(FeatureFlag.GP_AUTH_INVITATION_V2);
  const {
    contacts: { helpEmail },
    global: { companyName },
  } = usePublicConfig();

  if (isLoading) {
    return <LoadingSpinner />;
  }

  // Key on the flag so a flag transition (e.g. when the flag query settles)
  // remounts InvitationRegistration cleanly instead of swapping the hook it
  // calls mid-render — the latter would violate the rules of hooks and tear
  // down an in-flight check/complete request.
  return (
    <InvitationRegistration
      faqItems={getLPLoginFaqItems(helpEmail, companyName)}
      key={isInvitationV2 ? "invitation-v2" : "invitation-v1"}
      loginPath={LPAuthPaths.Login}
      useInvitationCheckHook={
        isInvitationV2 ? useInvestorInvestorInvitationCheck : useInvitationCheck
      }
      useInvitationCompleteHook={
        isInvitationV2
          ? useInvestorInvestorInvitationComplete
          : useInvitationComplete
      }
    />
  );
};
